// components/problems/problem-row-kebab-menu.tsx
import {
  ArrowDownToLine,
  ArrowUpToLine,
  MoreVertical,
  Star,
  Trash2,
} from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

interface ProblemRowKebabMenuProps {
  onRemove: () => void
  onAddToList: () => void
  onMoveToTop?: () => void
  onMoveToBottom?: () => void
}

export function ProblemRowKebabMenu({
  onRemove,
  onAddToList,
  onMoveToTop,
  onMoveToBottom,
}: ProblemRowKebabMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="text-muted-foreground hover:text-foreground rounded p-1 transition-colors"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreVertical className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
        <DropdownMenuItem onClick={onRemove}>
          <Trash2 className="mr-2 h-4 w-4" />
          Remove from List
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onAddToList}>
          <Star className="mr-2 h-4 w-4" />
          Add to List
        </DropdownMenuItem>
        {onMoveToTop && (
          <DropdownMenuItem onClick={onMoveToTop}>
            <ArrowUpToLine className="mr-2 h-4 w-4" />
            Move to Top
          </DropdownMenuItem>
        )}
        {onMoveToBottom && (
          <DropdownMenuItem onClick={onMoveToBottom}>
            <ArrowDownToLine className="mr-2 h-4 w-4" />
            Move to Bottom
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
